import { frontendURL } from 'dashboard/helper/URLHelper';

const ResumesIndex = () => import('./pages/ResumesIndex.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/resumes'),
      name: 'resumes_index',
      component: ResumesIndex,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
  ],
};
